import type { DeliveryChange } from './DeliveryChange';

export const config: DeliveryChange = {
    electronicDeliveryPayload: { mode: 'ELECTRONICALLY' },
    postalDeliveryPayload: { mode: 'POSTAL' },
    showElectronicDeliveryCard: false,
};
